// @noflow
import React from 'react'

import {
  Direction,
  ICON_COLOURS,
  IconColours
} from '@/components/elements/atoms/Icon/Icon'

import STYLES from './Chevron.module.sass'

type Props = {
  size: number
  accentColour: IconColours
  width?: number | string
  direction?: Direction
}

const Arrow = ({
  size,
  accentColour,
  width,
  direction = 'right'
}: Props): JSX.Element => {
  return (
    <svg
      fill="none"
      height={size}
      viewBox="0 0 31 26"
      width={width || '100%'}
      className={`${direction ? STYLES[direction] : ''}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="m14.2102.308369c.0718 0 .1433-.000002.215-.000676l.2553.141701c.1967.108466.393.217157.5868.331461l.2553.150684c.449.265661.9136.540311 1.3624.824611.7242.45834 2.3246 1.22793 4.0192 2.04244 1.7278.83045 3.5145 1.68919 4.3851 2.2304 1.0081.62654 2.062 1.2971 3.2221 2.0503.6339.4114 1.2215.93015 1.7965 1.58611.2034.23221.3125.5273.3844.7626v.9699c-.009.0613-.0179.1393-.0269.2172-.0183.1603-.0373.3258-.0658.4844-.1352.7619-.4957 1.3009-1.0711 1.6014-1.2492.6526-2.4664 1.5508-3.7204 2.7462-.5332.5082-1.0653 1.0377-1.5798 1.5497-.3087.307-.6175.614-.928.9187-1.4043 1.3762-3.0067 2.7373-5.0426 4.2841-.7169.5444-1.4515 1.0892-2.1617 1.6158l-.3903.2892c-.2959.2196-.6555.4568-1.0783.55-.0395.0085-.0786.0188-.1179.0292l-.0326.0085h-.1798c-.0161-.0195-.0324-.0388-.0501-.0564-.1963-.1947-.3021-.4087-.3231-.6539-.0177-.203-.0194-.402-.0051-.5915.0303-.4031.0731-.8129.1148-1.2091l.0114-.1118c.0013-.0072.0122-.029.0283-.0449l.1295-.1274c.1772-.1749.3606-.3559.5475-.5216.7463-.6627 1.4941-1.3229 2.2416-1.9832l1.3631-1.2048c1.5299-1.3539 2.6528-2.4767 3.6412-3.6407.0057-.0062.028-.017.0425-.024.0151-.0072.0301-.0144.0444-.0227l.1046-.0613-.1301-.1951-.1545-.0355c-.0816-.0186-.1629-.0371-.2437-.0573-.5921-.15-1.375-.333-2.1737-.4186-.5742-.0622-1.1472-.0707-1.6322-.0712-.8904-.0004-1.7815-.0107-2.6731-.0208-1.3597-.0155-2.7665-.0313-4.1482-.0117-1.64783.0233-1.90468.0442-2.41641.0862l-.24899.02c-.25173.0198-.51035.0564-.76032.0919-.48186.0684-.98023.139-1.45305.0922-.21734-.0217-.43449-.0444-.65184-.0669-.5418-.0563-1.10227-.1147-1.65468-.156-.82301-.062-1.53971-.0075-2.19116.1659-.18709.0494-.32426-.0007-.4744-.1738-.03871-.0445-.07408-.0925-.10788-.1415-.580121-.8316-.431554-2.011.00255-2.6988.39166-.6205.90811-.9358 1.535-.9376.18708.0036.37908.0171.56498.0341.10455.0097.2091.0191.31345.0259.24171.0155.48323.0301.72515.0444.28318.0169.56675.0339.84974.0526.15544.0103.31069.0236.46594.0366.29143.0249.59289.0503.89101.0554.23307.0057.90692-.0469 1.76275-.1111 1.04705-.0784 2.34996-.1758 3.29656-.2064.5507-.018 1.1019-.0272 1.6529-.0361.6819-.0115 1.387-.0232 2.0798-.0519 1.3711-.0573 2.7418-.1186 4.1129-.1821l.1947-.0084c.3253-.0139.6615-.0278.9905-.0754.1511-.0222.2945-.0813.4331-.1383.0823-.034.1647-.0681.2484-.0939.281-.0856.5632-.166.8456-.2461l.4082-.11659c.0285-.00808.0564-.01976.0851-.03188l.1904-.07501-.1171-.128c-.1144-.12486-.2272-.24995-.3394-.37436-.2535-.28116-.5155-.57197-.7833-.84212-.3257-.32877-.6014-.54637-.8934-.70604-.317-.17314-.813-.39075-1.4407-.66607-1.5552-.68246-3.6851-1.61688-5.1257-2.7624-.3832-.30541-.6517-.61599-.8443-.97664-.2639-.49472-.3441-.91152-.2523-1.31125.1865-.81091.6184-1.386472 1.2842-1.710971z"
        fill={ICON_COLOURS[accentColour]}
        fillRule="evenodd"
      />
    </svg>
  )
}

export default Arrow
